import React, { useEffect, useMemo, useState } from "react";
import grp1 from "../Images/Group/Campers/grp1.jpg";
import grp2 from "../Images/Group/Campers/grp2.jpg";
import grp3 from "../Images/Group/Campers/grp3.jpg";
import grp4 from "../Images/Group/Campers/grp4.JPG";
import grp5 from "../Images/Group/Campers/grp5.jpg";
import grp6 from "../Images/Group/Campers/grp6.JPG";
import grp9 from "../Images/Group/Campers/grp9.jpg";
import grp10 from "../Images/Group/Campers/grp10.jpg";
import grp11 from "../Images/Group/Campers/grp11.jpg";
import tgrp1 from "../Images/Group/Trekkers/tgrp1.jpg";
import tgrp2 from "../Images/Group/Trekkers/tgrp2.jpg";
import tgrp3 from "../Images/Group/Trekkers/tgrp3.jpg";
import tgrp4 from "../Images/Group/Trekkers/tgrp4.jpg";
import tgrp5 from "../Images/Group/Trekkers/tgrp5.jpg";
import tgrp6 from "../Images/Group/Trekkers/tgrp6.jpg";
import tgrp7 from "../Images/Group/Trekkers/tgrp7.jpg";
import tgrp8 from "../Images/Group/Trekkers/tgrp8.jpg";
import tgrp9 from "../Images/Group/Trekkers/tgrp9.jpg";
import tgrp10 from "../Images/Group/Trekkers/tgrp10.jpg";
import tgrp11 from "../Images/Group/Trekkers/tgrp11.jpg";
import tgrp12 from "../Images/Group/Trekkers/tgrp12.jpg";

const ImageCarousel = () => {
  const section1Images = useMemo(
    () => [grp1, grp5, grp2, grp9, grp4, grp6, grp3, grp10, grp11],
    [],
  );
  const section2Images = useMemo(
    () => [
      tgrp1,
      tgrp2,
      tgrp3,
      tgrp5,
      tgrp4,
      tgrp6,
      tgrp12,
      tgrp7,
      tgrp9,
      tgrp8,
      tgrp10,
      tgrp11,
    ],
    [],
  );

  const [activeSection, setActiveSection] = useState(1);
  const [currentImageIndex, setCurrentImageIndex] = useState(0);
  const images = activeSection === 1 ? section1Images : section2Images;

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentImageIndex((index) => (index + 1) % images.length);
    }, 3000);
    return () => clearInterval(interval);
  }, [images]);

  const changeSection = (section) => {
    setActiveSection(section);
    setCurrentImageIndex(0);
  };

  const showPrevious = () => {
    setCurrentImageIndex((index) => (index - 1 + images.length) % images.length);
  };

  const showNext = () => {
    setCurrentImageIndex((index) => (index + 1) % images.length);
  };

  return (
    <section className="w-full bg-gradient-to-b from-amber-50 to-white px-4 py-10 sm:px-6 sm:py-14">
      <div className="mx-auto max-w-6xl">
        <div className="mb-6 text-center">
          <p className="text-xs font-bold uppercase tracking-[0.18em] text-emerald-800">
            Moments from the trail
          </p>
          <h2 className="mt-2 text-3xl font-bold text-stone-900 sm:text-4xl">
            Shared adventures
          </h2>
        </div>
        <div className="mb-6 flex items-center justify-center gap-3">
          <button
            type="button"
            onClick={() => changeSection(1)}
            aria-pressed={activeSection === 1}
            className={`rounded-full px-5 py-2.5 text-sm font-semibold transition ${
              activeSection === 1
                ? "bg-emerald-800 text-white"
                : "bg-amber-100 text-stone-700 hover:bg-amber-200"
            }`}
          >
            Campers
          </button>
          <button
            type="button"
            onClick={() => changeSection(2)}
            aria-pressed={activeSection === 2}
            className={`rounded-full px-5 py-2.5 text-sm font-semibold transition ${
              activeSection === 2
                ? "bg-emerald-800 text-white"
                : "bg-amber-100 text-stone-700 hover:bg-amber-200"
            }`}
          >
            Trekkers
          </button>
        </div>

        <div className="relative mx-auto max-w-4xl">
          <div className="aspect-[4/3] w-full overflow-hidden rounded-3xl shadow-lg ring-1 ring-amber-900/10 sm:aspect-[16/9]">
            <img
              src={images[currentImageIndex]}
              alt={`${activeSection === 1 ? "Campers" : "Trekkers"} enjoying an outdoor adventure ${currentImageIndex + 1}`}
              className="h-full w-full object-cover transition duration-500"
            />
          </div>
          <button
            type="button"
            onClick={showPrevious}
            aria-label="Previous photo"
            className="absolute left-4 top-1/2 -translate-y-1/2 rounded-full bg-stone-950/60 p-3 text-lg text-white transition hover:bg-emerald-800 sm:text-2xl"
          >
            &#60;
          </button>
          <button
            type="button"
            onClick={showNext}
            aria-label="Next photo"
            className="absolute right-4 top-1/2 -translate-y-1/2 rounded-full bg-stone-950/60 p-3 text-lg text-white transition hover:bg-emerald-800 sm:text-2xl"
          >
            &#62;
          </button>
        </div>
      </div>
    </section>
  );
};

export default ImageCarousel;
